import React, { useState } from 'react';
import { useI18n } from './i18n';
import { downloadPdf } from './pdfExport';

// Button that downloads a PDF generated by the API from saved data.
// Props: path (API path, e.g. 'oil/<id>/pdf'), label (default: "PDF"), className, hint (small text next to the button).
function PdfButton({ path, label, className = 'reset-btn', hint, fallbackName }) {
  const { t } = useI18n();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const run = async () => {
    setBusy(true);
    setError(null);
    const result = await downloadPdf({ path, fallbackName });
    if (!result.ok) setError(result.message || t('reports.pdf_error'));
    setBusy(false);
  };

  return (
    <span className="report-pdf">
      <button type="button" className={className} onClick={run} disabled={busy}>
        {busy ? t('reports.pdf_busy') : (label || t('reports.pdf'))}
      </button>
      {hint && <small className="report-hint"> {hint}</small>}
      {error && <span className="message error report-pdf-error" role="alert">{error}</span>}
    </span>
  );
}

export default PdfButton;
